import React, { Component } from 'react'

class TableDurationInput extends Component {

    state = {
        data: ''
    }

    componentDidMount() {
        let data = this.state.data
        if (Array.isArray(this.props.data) && this.props.data.length > 0) {
            data = (this.props.data[0] ?? '00') + ':' + (this.props.data[1] ?? '00') + ':' + (this.props.data[2] ?? '00')
        }
        else {
            data = this.props.data
        }
        this.setState({ data })
    }


    changeInputValue(target) {
        let value = (target.validity.valid) ? target.value : null
        if (value !== null) {
            this.props.changeValue(this.props.header.key, value)
        }
    }


    render() {
        let styleInfo = this.props.styleInfo
        return (
            <div className="w-100 h-100 flexcc">
                {this.props.data && (
                    // <p className="text-small" style={{ color: '#051015', textOverflow: 'ellipsis', overflow: 'hidden', width: '100%' }}>{String(this.props.data)}</p>
                    <p className="" style={{ textOverflow: 'ellipsis', overflow: 'hidden', width: '100%', color: styleInfo?.textColor, fontWeight: styleInfo?.fontWeight, fontSize: styleInfo?.fontSize }}>{this.state.data}</p>
                )}
            </div>
        )
    }
}

export default TableDurationInput;